import React from "react";

class About extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    /**
     * Your ajax will goes here to get data then call setState
     */
  }

  render() {
    return (
      <React.Fragment>
        <section id="map-chain-lakes-loop" className="about-us gray-light-bg">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1360881.5239746475!2d-122.01258599999998!3d48.226419!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8096ec36a6c8ce33%3A0x167733863952c99b!2sArtist%20Point!5e0!3m2!1sen!2sus!4v1773001980325!5m2!1sen!2sus"
            width="100%"
            height="420">
          </iframe>
        </section>
      </React.Fragment>
    );
  }
}

export default About;

